import { Band } from './primitives/Band';
import { MonoKicker } from './primitives/MonoKicker';

export function ProblemBand() {
    return (
        <Band tone="oxblood">
            <div className="flex flex-col gap-12">
                <div className="flex max-w-2xl flex-col gap-4">
                    <MonoKicker data-reveal>
                        The problem with buying tools
                    </MonoKicker>
                    <h2
                        data-reveal
                        className="font-display text-[clamp(30px,4vw,40px)] leading-[1.15] text-balance"
                    >
                        Software doesn&rsquo;t come with anyone who knows your
                        practice.
                    </h2>
                    <p
                        data-reveal
                        className="text-[clamp(16px,1.4vw,18px)] leading-[1.55] text-muted-foreground"
                    >
                        The AI scribe market is crowded and most of it works.
                        That was never the hard part. The hard part is the six
                        weeks after you sign up.
                    </p>
                </div>

                <div className="grid grid-cols-[repeat(auto-fit,minmax(min(300px,100%),1fr))] gap-6">
                    <div
                        data-reveal
                        className="flex flex-col gap-4 rounded-[16px] border border-border bg-card p-8"
                    >
                        <MonoKicker>Buying another app</MonoKicker>
                        <p className="text-[16px] leading-[1.55]">
                            You get a login and a help centre. Someone on your
                            staff quietly becomes the reluctant expert. Six
                            weeks later it&rsquo;s half-configured, the
                            templates never got finished, and everyone&rsquo;s
                            drifted back to the old way.
                        </p>
                    </div>
                    <div
                        data-reveal
                        className="flex flex-col gap-4 rounded-[16px] border border-border bg-card p-8"
                    >
                        <MonoKicker>Bringing on a team</MonoKicker>
                        <p className="text-[16px] leading-[1.55] font-semibold">
                            We learn how your practice actually runs, build the
                            thing around it, and stay on to change it when you
                            do. Nobody on your staff has to become an expert in
                            anything.
                        </p>
                    </div>
                </div>
            </div>
        </Band>
    );
}
